/** biome-ignore-all lint/suspicious/noExplicitAny: <explanation> */
import { relations } from "drizzle-orm";
import {
	integer,
	type PgTableWithColumns,
	pgTable,
	serial,
	text,
	timestamp,
	index,
} from "drizzle-orm/pg-core";
import { channels } from "../channel/channel-schema";
import { workspace } from "../workspace/workspace-schema";

export const messages: PgTableWithColumns<any> = pgTable(
	"messages", 
	{
		id: serial("id").primaryKey(),
		workspaceId: serial("workspace_id")
			.notNull()
			.references(() => workspace.id),
		channelId: serial("channel_id")
			.notNull()
			.references(() => channels.id),
		senderId: text("sender_id").notNull(),
		// senderName: text("sender_name").notNull(),
		text: text("text").notNull(),
		htmlContent: text("html_content"), // Rich text HTML content (nullable for backward compatibility)
		tags: text("tags").array(), // Array of tags for filtering (e.g., ["urgent", "announcement", "question", "update"])
		createdAt: timestamp("created_at").notNull().defaultNow(),
		editedAt: timestamp("edited_at"),
		threadRootId: integer("thread_root_id").references(() => messages.id), // nullable; points to thread root
	},
	(t) => [
		index("messages_thread_root_id_idx").on(t.threadRootId),
	]
);

export const messageAttachments = pgTable("message_attachments", {
	id: serial("id").primaryKey(),
	messageId: serial("message_id")
		.notNull()
		.references(() => messages.id, { onDelete: "cascade" }),
	url: text("url").notNull(), // Link to file in storage bucket
	type: text("type"), // e.g. "image/png", "pdf", etc
	name: text("name"), // Original filename
	size: integer("size"), // Bytes
});

export const messageMentions = pgTable("message_mentions", {
	messageId: serial("message_id")
		.notNull()
		.references(() => messages.id, { onDelete: "cascade" }),
	userId: text("user_id").notNull(),
	// PK: (messageId, userId)
});

export const messageReactions = pgTable("message_reactions", {
	messageId: serial("message_id")
		.notNull()
		.references(() => messages.id, { onDelete: "cascade" }),
	emoji: text("emoji").notNull(), // "👍", ":fire:", custom emoji shortname or unicode
	userId: text("user_id").notNull(),
	// PK: (messageId, emoji, userId)
});

export const messagesRelations = relations(messages, ({ one, many }) => ({
	workspace: one(workspace, {
		fields: [messages.workspaceId],
		references: [workspace.id],
	}),
	channel: one(channels, {
		fields: [messages.channelId],
		references: [channels.id],
	}),
	threadRoot: one(messages, {
		fields: [messages.threadRootId],
		references: [messages.id],
	}),
	attachments: many(messageAttachments),
	mentions: many(messageMentions),
	reactions: many(messageReactions),
}));

export const messageAttachmentsRelations = relations(
	messageAttachments,
	({ one }) => ({
		message: one(messages, {
			fields: [messageAttachments.messageId],
			references: [messages.id],
		}),
	}),
);

export const messageMentionsRelations = relations(
	messageMentions,
	({ one }) => ({
		message: one(messages, {
			fields: [messageMentions.messageId],
			references: [messages.id],
		}),
	}),
);

export const messageReactionsRelations = relations(
	messageReactions,
	({ one }) => ({
		message: one(messages, {
			fields: [messageReactions.messageId],
			references: [messages.id],
		}),
	}),
);
